import axios from "axios/index";
import {i18n} from '../main';


export const apiLink = () => {
    return process.env.API_LINK === null ? window.location.origin + '/api/' : process.env.API_LINK;
};

export default {
    getAxiosConfig(queryParams = {}) {
        if (null !== localStorage.getItem('csrf')) {
          localStorage.setItem('authTokenAcquired', JSON.stringify(Date.now()))
        }
        const UNAUTHORIZED = 401;

        axios.defaults.headers.common['Authorization'] = localStorage.getItem('csrf');
        axios.interceptors.response.use(
            response => response,
            error => {
                const {status} = error.response;
                if (status === UNAUTHORIZED) {
                    console.log('validate login');
                }
                return Promise.reject(error);
            }
        );


        if (process.env.NODE_ENV === 'development') {
            queryParams.XDEBUG_SESSION_START = 'TP';
        }
        queryParams.lang = i18n.locale;
        return {
            withCredentials: true,
            params: queryParams
        };
    },

    getRequest(store, link, errorMessage = 'Internal server error') {
        return new Promise((resolve, reject) => {
            this.get(link).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
                store.dispatch('alert/danger', errorMessage, {root: true});
            });
        });
    },

    get(link) {
        return axios.get(apiLink() + link.replace(apiLink(), ''), this.getAxiosConfig());
    },

    postRequest(store, link, data = {}, errorMessage = 'Internal server error') {
        return new Promise((resolve, reject) => {
            this.post(link, data).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
                store.dispatch('alert/danger', errorMessage, {root: true});
            });
        });
    },

    post(link, data = {}) {
        return axios.post(apiLink() + link.replace(apiLink(), ''), data, this.getAxiosConfig());
    },

    put(link, data = {}) {
        return axios.put(apiLink() + link.replace(apiLink(), ''), data, this.getAxiosConfig());
    },

    deleteRequest(store, link, errorMessage = 'Item was not deleted') {
        return new Promise((resolve, reject) => {
            this.delete(link).then(response => {
                resolve(response);
            }).catch(error => {
                store.dispatch('alert/warning', errorMessage, {root: true});
                reject(error.response);
            });
        });
    },

    delete(link) {
        return axios.delete(apiLink() + link.replace(apiLink(), ''), this.getAxiosConfig());
    },

    getProfile() {
        return new Promise((resolve, reject) => {
            this.get('account').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response);
            });
        });
    },
}



// WEBPACK FOOTER //
// ./src/store/api.js